import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from 'nuvo-react'

export const headerSelect: ThemeAPI['headerSelect'] = {
  root: {
    borderRadius: theme.dimensions.s8,
  },
  pageHeader: {
    root: {
      backgroundColor: theme.colors.grey000White,
    },
    title: {
      fontSize: theme.fontSizes[400],
    },
    description: {
      fontSize: theme.fontSizes[200],
    },
  },
  content: {
    fontSize: theme.fontSizes[100],
    color: theme.colors.grey800,
  },
  sheetName: {
    root: {
      backgroundColor: theme.colors.grey000White,
      borderRadius: theme.dimensions.s8,
      padding: theme.dimensions.s16,
    },
    title: {
      color: theme.colors.radicalRed800,
    },
    description: {
      color: theme.colors.grey800,
    },
    border: {
      backgroundColor: theme.colors.grey000White,
    },
  },
  fullScreen: {
    root: {
      width: theme.dimensions.s200,
    },
    icon: {
      stroke: theme.colors.grey1000,
    },
  },
  table: {
    th: {
      backgroundColor: theme.colors.radicalRed800,
      borderColor: theme.colors.radicalRed800,
      color: theme.colors.white,
    },
    td: {
      backgroundColor: theme.colors.grey100,
      borderColor: theme.colors.grey200,
    },
    scrollbar: {
      navigatorColor: theme.colors.grey200,
      backgroundColor: theme.colors.grey800,
    },
    selectRowColor: theme.colors.radicalRed800,
  },
  progressBar: {
    root: {
      backgroundColor: theme.colors.grey000White,
    },
    progress: {
      navigatorColor: theme.colors.grey200,
      backgroundColor: theme.colors.grey800,
    },
  },
  sheetNameSelected: {
    root: {
      backgroundColor: theme.colors.grey000White,
      borderRadius: theme.dimensions.s8,
    },
    title: {
      color: theme.colors.grey1000,
    },
    description: {
      color: theme.colors.grey600,
    },
    border: {
      backgroundColor: theme.colors.grey000White,
    },
  },
}
